import { Link } from "react-router-dom";
import { Button, Result } from "antd";
import React from "react";

const NotFound = () => {
  return (
    <Result
      status="404"
      title="Not Found"
      subTitle="Página no encontrada"
      extra={
        <Link to="/">
          <Button type="primary">Regresar</Button>
        </Link>
      }
    />
  );
};

export default NotFound;
